import Image from './Image';

export class Arena extends Image {}